import Repository from './Repository';

const resource = '/users';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    me()                {return Repository.get(`/me`);},
    meUpdate(payload)   {return Repository.put(`/me/update`, payload);},
    getAttachments(id)  {return Repository.get(`${resource}/attachments/${id}`);},
}